import React from 'react'
import { observer, inject } from 'mobx-react'
import { withTranslation } from 'react-i18next'
import Icon from 'components/common/Icon'
import { checkboxIcon } from 'utils.js'

const ViewMenuItems = ({ t, uiStore, selectionStore }) => {
  const [isFullScreen, setIsFullScreen] = React.useState(Boolean(document.fullscreenElement))

  React.useEffect(() => {
    const onFullScreenChange = () => setIsFullScreen(Boolean(document.fullscreenElement))
    document.addEventListener('fullscreenchange', onFullScreenChange)
    return () => document.removeEventListener('fullscreenchange', onFullScreenChange)
  }, [])

  const toggleFullScreen = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen()
    } else {
      document.documentElement.requestFullscreen()
    }
  }

  const getMap = () => uiStore.map && uiStore.map.leafletElement

  // Re-fit the map to the bounds of whatever is currently selected
  // (target group, shape, marker/POI...), like when it was first selected.
  const zoomReset = () => {
    const item = selectionStore.item
    if (item && typeof item.bounds === 'function') {
      uiStore.setBounds(item.bounds())
    } else {
      uiStore.resetBounds()
    }
  }

  const zoomIn = () => {
    const map = getMap()
    if (map) map.zoomIn()
  }

  const zoomOut = () => {
    const map = getMap()
    if (map) map.zoomOut()
  }

  return (
    <>
      <button
        type='button'
        className='toolbar__sublist-btn toolbar__sublist-btn--check'
        // Keep the menu open so the checkbox state change is visible.
        onClick={(e) => { e.stopPropagation(); uiStore.toggleMarkerLabels() }}
      >
        <Icon id={checkboxIcon(uiStore.showMarkerLabels)} />
        {t('MAP_SETTINGS.MARKER_LABELS')}
      </button>
      <button
        type='button'
        className='toolbar__sublist-btn toolbar__sublist-btn--check'
        onClick={(e) => { e.stopPropagation(); uiStore.toggleZoomToSelected() }}
      >
        <Icon id={checkboxIcon(uiStore.zoomToSelected)} />
        {t('MAP_SETTINGS.ZOOM_TO_SELECTED')}
      </button>
      <hr className='toolbar__sublist-separator' />
      <button type='button' className='toolbar__sublist-btn' onClick={() => window.location.reload()}>
        {t('TOOLBAR.RELOAD_PAGE')}
      </button>
      <hr className='toolbar__sublist-separator' />
      <button type='button' className='toolbar__sublist-btn' onClick={toggleFullScreen}>
        {isFullScreen ? t('TOOLBAR.EXIT_FULL_SCREEN') : t('TOOLBAR.ENTER_FULL_SCREEN')}
      </button>
      <button type='button' className='toolbar__sublist-btn' onClick={zoomReset}>
        {t('TOOLBAR.ZOOM_RESET')}
      </button>
      <button type='button' className='toolbar__sublist-btn' onClick={zoomIn}>
        {t('TOOLBAR.ZOOM_IN')}
      </button>
      <button type='button' className='toolbar__sublist-btn' onClick={zoomOut}>
        {t('TOOLBAR.ZOOM_OUT')}
      </button>
    </>
  )
}

export default withTranslation()(inject('uiStore', 'selectionStore')(observer(ViewMenuItems)))
